import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../library/assets/Arrow_alt_ltop.svg'
import _imports_1 from '../library/assets/tick.svg'


const _withScopeId = n => (_pushScopeId("data-v-6be24714"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asahi-bs-footer" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-lg col-fixed-width brand" }
const _hoisted_5 = { class: "col asahi-bs-footer-accordion" }
const _hoisted_6 = {
  key: 0,
  class: "text-center mb-3 catalog-link"
}
const _hoisted_7 = {
  class: "accordion",
  id: "asahi-bs-footer-accordion"
}
const _hoisted_8 = ["data-bs-target", "aria-controls"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-accordion-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 4L8 11L15 4",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "accordion-body" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  src: _imports_0,
  class: "arrow-alt-ltop"
}
const _hoisted_14 = { class: "footer-section-title" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href", "target"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "col-12 col-lg col-fixed-width" }
const _hoisted_19 = { class: "language-picker-container" }
const _hoisted_20 = { class: "asahi-bs-footer-accordion-language" }
const _hoisted_21 = { class: "accordion-item" }
const _hoisted_22 = { class: "accordion-header" }
const _hoisted_23 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": '#asahi-bs-footer-accordion-collapse-language',
  "aria-expanded": "false",
  "aria-controls": 'asahi-bs-footer-accordion-collapse-language'
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-accordion-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 4L8 11L15 4",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_25 = {
  id: 'asahi-bs-footer-accordion-collapse-language',
  class: "accordion-collapse collapse"
}
const _hoisted_26 = { class: "accordion-body" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "asahi-language" }
const _hoisted_29 = {
  key: 0,
  class: "language-selected-icon",
  src: _imports_1
}
const _hoisted_30 = { class: "asahi-bs-footer-copyright" }
const _hoisted_31 = { class: "container text-center" }
const _hoisted_32 = { class: "row justify-content-center" }
const _hoisted_33 = { class: "col-12 col-lg-auto" }
const _hoisted_34 = { class: "col-12 col-lg-auto footer-links" }
const _hoisted_35 = ["href", "target"]
const _hoisted_36 = ["href", "target"]
const _hoisted_37 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiLogoNew = _resolveComponent("AsahiLogoNew")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SocialBannerNew = _resolveComponent("SocialBannerNew")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AsahiLogoNew, {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.navigateToPath({label: 'Logo', link: '/' })), ["prevent"]))
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combinedFooterData, (value) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: value.name
              }, [
                (value.name === 'products_catalogue')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_router_link, {
                        to: "/catalog/products",
                        class: "primary-white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(value.label), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combinedFooterData, (value, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "accordion-item",
                  key: value.name
                }, [
                  (value.label && value.name !== 'products_catalogue')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["accordion-header", [value.label === 'Create an order' ? 'd-none' : '']])
                      }, [
                        _createElementVNode("button", {
                          class: "accordion-button collapsed",
                          type: "button",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": '#asahi-bs-footer-accordion-collapse-' + index,
                          "aria-expanded": "false",
                          "aria-controls": 'asahi-bs-footer-accordion-collapse-' + index
                        }, [
                          _createElementVNode("span", null, _toDisplayString(value.label), 1),
                          _hoisted_9
                        ], 8, _hoisted_8)
                      ], 2))
                    : _createCommentVNode("", true),
                  (value.label)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        id: 'asahi-bs-footer-accordion-collapse-' + index,
                        class: "accordion-collapse collapse"
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.children, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.label,
                              class: "py-2"
                            }, [
                              (item.href && item?.name !== 'Academy' && item?.name !== 'Pub Menu')
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: item.href
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.menuNavigate(item)),
                                    class: "external-link"
                                  }, [
                                    _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                    (item.name == 'Pub Menu' || item.name == 'Academy')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_12))
                            ]))
                          }), 128))
                        ])
                      ], 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combinedFooterData, (section) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 col-md col-fixed-width asahi-bs-footer-menu",
              key: section.title
            }, [
              (section.name === 'products_catalogue')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/catalog/products",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.navigateToPath({label: 'Products catalogue', link: '/catalog/products' })), ["prevent"])),
                    class: "external-link m-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(section.title || section.label), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    href: section.link,
                    class: "footer-section-title"
                  }, _toDisplayString(section.title || section.label), 9, _hoisted_15)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((section.links || section.children), (link) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: link.label
                }, [
                  (link.label && link?.name !== 'Academy' && link?.name !== 'Pub Menu')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: link.href || link.link,
                        target: section.links ? '_blank' : '',
                        rel: "noopener noreferrer",
                        class: "external-link"
                      }, _toDisplayString(link.label), 9, _hoisted_16))
                    : (link?.label)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.menuNavigate(link)),
                          class: "external-link"
                        }, _toDisplayString(link.label), 9, _hoisted_17))
                      : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_SocialBannerNew),
            _createElementVNode("div", _hoisted_19, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", _hoisted_23, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getFullLanguageName(_ctx.activeLanguage)), 1),
                      _hoisted_24
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.language, (lang) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: lang,
                          class: "py-2 clickable",
                          onClick: ($event: any) => (_ctx.changeLanguage(lang))
                        }, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("p", {
                              class: _normalizeClass(["asahi-lang-label", { 'selected-language': _ctx.activeLanguage === lang }])
                            }, _toDisplayString(_ctx.getFullLanguageName(lang)), 3),
                            (_ctx.activeLanguage === lang)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_27))
                      }), 128))
                    ])
                  ])
                ])
              ])), [
                [_directive_click_outside, _ctx.closeLangAccordion]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, " © Copyright Asahi CE & Europe Services s.r.o., " + _toDisplayString(_ctx.currentYear), 1),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("a", {
              href: _ctx.privacyPolicy[0]?.href,
              target: _ctx.privacyPolicy[0]?.target
            }, _toDisplayString(_ctx.privacyPolicy[0]?.label), 9, _hoisted_35),
            _createElementVNode("a", {
              href: _ctx.termsOfUse[0]?.href,
              target: _ctx.termsOfUse[0]?.target
            }, _toDisplayString(_ctx.termsOfUse[0]?.label), 9, _hoisted_36),
            _createElementVNode("a", {
              href: _ctx.cookies[0]?.href,
              target: _ctx.cookies[0]?.target
            }, _toDisplayString(_ctx.cookies[0]?.label), 9, _hoisted_37)
          ])
        ])
      ])
    ])
  ], 64))
}